module.exports = __webpack_public_path__ + "img/pr-6.7ca8ac95.png";